import { Component, ChangeDetectionStrategy, AfterViewInit, ElementRef, OnDestroy, Input, inject } from '@angular/core';
import { MetrixInitService } from '@shared/components';
import { PopupService } from '@shared/popup';
import { WindowService } from '@shared/window';
import { Subscription } from 'rxjs';
import { mergeMap, tap } from 'rxjs/operators';
import { HttpService } from '../../services/http.service';

import { MetrixConfiguratorPopupComponent } from './metrix-confiturator-popup/metrix-configurator-popup.component';

@Component({
    selector: 'app-metrix-configurator',
    templateUrl: './metrix-configurator.component.html',
    styleUrls: ['./metrix-configurator.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [PopupService],
})
export class MetrixConfiguratorComponent implements AfterViewInit, OnDestroy {
    private metrixInitService = inject(MetrixInitService);
    private elementRef = inject(ElementRef);
    private windowService = inject(WindowService);
    private popupService = inject(PopupService);
    private httpService = inject(HttpService);

    private _snapshotId?: string;

    @Input()
    set snapshotId(snapshotId: string | null) {
        if (snapshotId !== null) {
            this._snapshotId = snapshotId;
            if (this.windowService.isBrowser && snapshotId) {
                this.metrixInitService.load(snapshotId);
                const top = this.elementRef.nativeElement.getBoundingClientRect().top + document.documentElement.scrollTop - 24;
                this.windowService.scrollTo(top);
            }
        }
    }

    get snapshotId(): string | undefined {
        return this._snapshotId;
    }

    @Input() euroRate!: number;

    subsriptions$ = new Subscription();

    ngAfterViewInit(): void {
        if (this.windowService.isBrowser) {
            this.metrixInitService.euroRate = this.euroRate;
            this.metrixInitService.append(this.elementRef);
        }

        this.subsriptions$.add(
            this.metrixInitService.createOrder$
                .pipe(
                    mergeMap((containerId) => this.httpService.getSnapshotId(containerId)),
                    tap((snapshotId) => {
                        this.popupService.open(MetrixConfiguratorPopupComponent, { id: snapshotId });
                    }),
                )
                .subscribe(),
        );
    }

    ngOnDestroy(): void {
        if (this.windowService.isBrowser) {
            this.metrixInitService.detache(this.elementRef);
        }
        this.subsriptions$.unsubscribe();
    }
}
